import axios from 'axios';

// API base URL - fallback to production URL if env var is not set
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://attendance-system-way0.onrender.com';

export const authService = {
  // Sign up user
  signup: async (userData) => {
    const response = await axios.post(`${API_BASE_URL}/api/auth/signup`, userData);
    return response.data;
  },

  // Login admin
  login: async (credentials) => {
    const response = await axios.post(`${API_BASE_URL}/api/auth/login`, credentials);
    return response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/auth/profile`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Change password
  changePassword: async (passwordData) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_BASE_URL}/api/auth/change-password`, passwordData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Setup initial admin
  setupAdmin: async (adminData) => {
    const response = await axios.post(`${API_BASE_URL}/api/auth/setup`, adminData);
    return response.data;
  },

  // Logout (client-side)
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Get stored user data
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Store user data
  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
  },

  // Store token
  setToken: (token) => {
    localStorage.setItem('token', token);
  }
};
